// extracted by mini-css-extract-plugin
export default {"alert":"ModalMedicineRequest__alert--yluE3"};